import React from "react";
import "./ProjectDetails.css";
import { useContext } from "react";
import { ProjectContext } from "../context/ProjectContext";


const ProjectOverview = () => {
  const { projectDetails, loadingProject } = useContext(ProjectContext);
  if (loadingProject) return <p>Loading...</p>;
  if (!projectDetails) return null;

  return (
    <div className="card csr-card">
      {/* Header */}
      <div className="csr-card-header">
        <div className="csr-icon">
          <i className="fa-regular fa-file-lines"></i>
        </div>
        <h5 className="mb-0">Project Overview</h5>
      </div>

      {/* Description */}
      <div className="csr-section">
  <h6 className="csr-subtitle">Description</h6>

  <div
    className="csr-text"
    dangerouslySetInnerHTML={{
      __html: projectDetails.description1
    }}
  />
</div>


      <hr />

      {/* Objectives */}
      <div className="csr-section">
        <h6 className="csr-subtitle">Project Objectives</h6>
       <div
    className="csr-text"
    dangerouslySetInnerHTML={{
      __html: projectDetails.project_objective
    }}
  >
</div>
</div>
      

      <hr />

      {/* Beneficiaries */}
      <div className="csr-section">
        <h6 className="csr-subtitle">Target Beneficiaries</h6>

        <div className="csr-beneficiary-box">
          <div className="beneficiary-icon">
            <i className="fa-solid fa-users"></i>
          </div>
         <div className="mb-0">
  {/* CKEditor HTML */}
  <div
    className="csr-text"
    dangerouslySetInnerHTML={{
      __html: projectDetails.target_beneficiaries
    }}
  />

  {/* Plain number */}
  {/* <p className="mt-2 fw-semibold">
    Target Beneficiaries: {projectDetails.total_beneficiaries} +
  </p> */}
</div>

        </div>
      </div>
    </div>
  );
};

export default ProjectOverview;